module.exports = __webpack_public_path__ + "img/icon_top.b0f2262e.png";